<template>
  <div id="page-user-view">
    <vs-alert color="danger" title="User Not Found" :active.sync="event_not_found">
      <span>Event record with id: {{ $route.params.id }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'associate-events'}" class="text-inherit underline">All Events</router-link>
      </span>
    </vs-alert>

    <div id="user-data" v-if="event_data">
      <vx-card title="Event Details" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <!--<div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="event_data.avatar" class="rounded w-full" />
            </div>
          </div>-->

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Event Name</td>
                <td>{{ event_data.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Event Date</td>
                <td>{{ event_data.event_date }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Event County</td>
                <td>{{ event_data.county_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Event Location</td>
                <td>{{ event_data.location }}</td>
              </tr>

            </table>
          </div>

          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Bride Name</td>
                <td><router-link :to="`/associate/users/bride/view/${event_data.user.id}`" class="text-inherit underline hover:text-primary">{{ event_data.user.name }}</router-link></td>
              </tr>
              <tr>
                <td class="font-semibold">Guest Count</td>
                <td>{{ event_data.guest_count }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Service Requests </td>
                <td>{{ event_data.service_requests }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- /Information - Col 2 -->
          <!--<div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button
              icon-pack="feather"
              icon="icon-edit"
              class="mr-4"
              :to="{name: 'event-edit', params: { id: $route.params.id }}"
            >Edit</vs-button>
            <vs-button
              type="border"
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              @click="confirmDeleteRecord"
            >Delete</vs-button>
          </div>-->
        </div>
      </vx-card>

      <vx-card v-if="event_data.service_requests_details.length">
        <vs-tabs>
          <vs-tab label="Service Requests" icon-pack="feather" icon="icon-file">
            <div>
              <vs-table @selected="directToServiceRequest" max-items="10" pagination :data="event_data.service_requests_details">
                <template slot="thead">
                  <vs-th>Category Name</vs-th>
                  <vs-th>County</vs-th>
                  <vs-th>Location</vs-th>
                  <vs-th>Vendor Matched</vs-th>
                  <vs-th>Quotes</vs-th>
                  <vs-th>Budget</vs-th>
                  <vs-th sort-key="is_accepted">Accepted</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].category_name">{{ data[indextr].category_name }}</vs-td>

                    <vs-td :data="data[indextr].county_name">{{ data[indextr].county_name }}</vs-td>

                    <vs-td :data="data[indextr].location">{{ data[indextr].location }}</vs-td>

                    <vs-td :data="data[indextr].vendors_matched">{{ data[indextr].vendors_matched }}</vs-td>

                    <vs-td :data="data[indextr].no_of_quotes">{{ data[indextr].no_of_quotes }}</vs-td>

                    <vs-td :data="data[indextr].budget">${{ data[indextr].budget }}</vs-td>

                    <vs-td :data="data[indextr].quote_already_accepted"><feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', (data[indextr].quote_already_accepted ? 'text-primary' : 'text-grey')]" /></vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moduleSupport from '@/store/support/moduleSupport.js'

export default {
  data () {
    return {
      event_data: null,
      event_not_found: false
    }
  },
  computed: {
    userAddress () {
      let str = ''
      for (const field in this.event_data.location) {
        str += `${field} `
      }
      return str
    }
  },
  methods: {
    directToServiceRequest (tr) {
      this.$router
        .push(`/associate/service-request/view/${tr.id}`)
        .catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.event_data.name}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      /*this.$router.push({ name: "events" })
      this.showDeleteSuccess()*/

      /* UnComment below lines for enabling true flow if deleting user */
      this.$store.dispatch('support/deleteEvent', this.event_data.id)
        .then(()   => { this.$router.push({name:'events'}); this.showDeleteSuccess() })
        .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Event Deleted',
        text: 'The event was successfully deleted'
      })
    }
  },
  created () {
    this.$emit('changeRouteTitle', 'Event')
    // Register Module UserManagement Module
    if (!moduleSupport.isRegistered) {
      this.$store.registerModule('support', moduleSupport)
      moduleSupport.isRegistered = true
    }

    const eventId = this.$route.params.id
    this.$store
      .dispatch('support/fetchEvent', eventId)
      .then((res) => {
        this.event_data = res.data.data
      })
      .catch((err) => {
        if (err.response.status === 404) {
          this.event_not_found = true
          return
        }
        console.error(err)
      })
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
